import React, { createContext, useContext, useState, useEffect, startTransition, use } from 'react';
import Cookies from 'js-cookie';
import useFetch from '../useFetch';
import { useDispatch } from 'react-redux';
import { resetCart, addToCart } from '../../Store/reducers/cartReducer';
import { clearCartOnServer } from '../../Store/reducers/cartReducer';
const API_URL = process.env.REACT_APP_API_URL;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(undefined);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();


    useEffect(() => {
        const cookieUser = Cookies.get('user');
        const cookieToken = Cookies.get('token');
        if (cookieToken) setToken(cookieToken);
        if (cookieUser) setUser(JSON.parse(cookieUser));
        setLoading(false);
    }, []);



    useEffect(() => {
        if (!user
        ) return
        Cookies.set('user', JSON.stringify(user), { expires: 7, secure: true });
    }, [user]);



    const login = async ({ identifier, password }) => {
        try {
            const res = await fetch(`${API_URL}/auth/local`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ identifier, password })
            });
            const data = await res.json();
            if (data.jwt) {
                Cookies.set('token', data.jwt, { expires: 7, secure: true });
                setToken(data.jwt);
                const profileRes = await fetch(`${API_URL}/users/me?populate=*`, {
                    headers: { Authorization: `Bearer ${data.jwt}` }
                });
                const profileData = await profileRes.json();
                setUser(profileData);
                return { success: true };
            } else {
                return { success: false, errorId: 'login_failed', error: data.error?.message };
            }
        } catch (err) {
            return { success: false, errorId: 'network_error', error: err.message };
        }
    };

    const register = async ({ username, email, password }) => {
        try {
            const res = await fetch(`${API_URL}/auth/local/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, email, password }),
            });
            const data = await res.json();
            if (res.ok) {
                return { success: true };
            } else {
                const taken = /already taken/i.test(data.error?.message || "");
                return { success: false, errorId: taken ? 'register_taken' : 'register_failed', error: data.error?.message };

            }
        } catch (err) {
            return { success: false, errorId: 'network_error' };
        }
    };
    async function getUserProfile(userId, jwt) {
        try {
            const response = await fetch(`${API_URL}/api/users/${userId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching user profile:', error);
            throw error;
        }
    }

    const logout = async () => {
        if (token) {
            await dispatch(clearCartOnServer(token));
        }
        Cookies.remove("token");
        Cookies.remove("user");
        setToken(null);
        setUser(null);
        dispatch(resetCart());
    };


    return (
        <AuthContext.Provider value={{ user, token, login, register, logout, loading }}>            {children}
        </AuthContext.Provider>
    );

};

export const useAuth = () => {
    return useContext(AuthContext);
};

